import { businessTypes, type BusinessType, type Locale } from '@seaa/shared'

export const businessTypeOptions = businessTypes

const labels: Record<BusinessType, Record<Locale, string>> = {
  sports_venue: { en: 'Sports venue', ar: 'منشأة رياضية', de: 'Sportstätte', nl: 'Sportlocatie' },
  fitness: { en: 'Fitness', ar: 'لياقة بدنية', de: 'Fitness', nl: 'Fitness' },
  beauty_wellness: { en: 'Beauty & wellness', ar: 'تجميل وعناية', de: 'Schönheit & Wellness', nl: 'Schoonheid & wellness' },
  professional_services: { en: 'Professional services', ar: 'خدمات مهنية', de: 'Professionelle Dienstleistungen', nl: 'Professionele diensten' },
  education: { en: 'Education', ar: 'تعليم', de: 'Bildung', nl: 'Onderwijs' },
  events: { en: 'Events', ar: 'فعاليات', de: 'Veranstaltungen', nl: 'Evenementen' },
  coworking: { en: 'Coworking', ar: 'مساحات عمل مشتركة', de: 'Coworking', nl: 'Coworking' },
  rentals: { en: 'Rentals', ar: 'تأجير', de: 'Vermietung', nl: 'Verhuur' },
  other: { en: 'Other', ar: 'أخرى', de: 'Sonstiges', nl: 'Overig' },
}
const unspecified: Record<Locale, string> = { en: 'Unspecified', ar: 'غير محدد', de: 'Nicht angegeben', nl: 'Niet opgegeven' }
const unknown: Record<Locale, string> = { en: 'Unknown', ar: 'غير معروف', de: 'Unbekannt', nl: 'Onbekend' }

export function businessTypeLabel(value: string | null | undefined, locale: string): string {
  const language: Locale = locale === 'ar' || locale === 'de' || locale === 'nl' ? locale : 'en'
  if (!value) return unspecified[language]
  return Object.hasOwn(labels, value) ? labels[value as BusinessType][language] : unknown[language]
}
